var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluedeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.5C0 2.22386 0.246243 2 0.55 2H10.45C10.7538 2 11 2.22386 11 2.5C11 2.77614 10.7538 3 10.45 3H0.55C0.246243 3 0 2.77614 0 2.5Z",
    fill: "#567FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 1.09091C4.22582 1.09091 4.08274 1.14838 3.97725 1.25067C3.87176 1.35296 3.8125 1.4917 3.8125 1.63636V2.18182H7.1875V1.63636C7.1875 1.4917 7.12824 1.35296 7.02275 1.25067C6.91726 1.14838 6.77418 1.09091 6.625 1.09091H4.375ZM8.3125 2.18182V1.63636C8.3125 1.20237 8.13471 0.786157 7.81824 0.47928C7.50177 0.172402 7.07255 0 6.625 0H4.375C3.92745 0 3.49823 0.172402 3.18176 0.47928C2.86529 0.786157 2.6875 1.20237 2.6875 1.63636V2.18182H1.5625C1.25184 2.18182 1 2.42603 1 2.72727V10.3636C1 10.7976 1.17779 11.2138 1.49426 11.5207C1.81072 11.8276 2.23995 12 2.6875 12H8.3125C8.76005 12 9.18927 11.8276 9.50574 11.5207C9.82221 11.2138 10 10.7976 10 10.3636V2.72727C10 2.42603 9.74816 2.18182 9.4375 2.18182H8.3125ZM2.125 3.27273V10.3636C2.125 10.5083 2.18426 10.647 2.28975 10.7493C2.39524 10.8516 2.53832 10.9091 2.6875 10.9091H8.3125C8.46168 10.9091 8.60476 10.8516 8.71025 10.7493C8.81574 10.647 8.875 10.5083 8.875 10.3636V3.27273H2.125Z",
    fill: "#567FBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5C4.77614 5 5 5.22386 5 5.5V8.5C5 8.77614 4.77614 9 4.5 9C4.22386 9 4 8.77614 4 8.5V5.5C4 5.22386 4.22386 5 4.5 5Z",
    fill: "#567FBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5C6.77614 5 7 5.22386 7 5.5V8.5C7 8.77614 6.77614 9 6.5 9C6.22386 9 6 8.77614 6 8.5V5.5C6 5.22386 6.22386 5 6.5 5Z",
    fill: "#567FBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluedeleteIcon);
export default __webpack_public_path__ + "static/media/bluedeleteIcon.0f69bf2d2634bd9686cfb9d71b3cefd1.svg";
export { ForwardRef as ReactComponent };